<template>
  <v-menu
    v-model="dropdown"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider
        ref="date"
        :name="name"
        :rules="rules"
        v-slot="{ errors }"
      >
        <v-text-field
          :disabled="disabled"
          v-model="dateFormatted"
          :label="label"
          :name="name"
          :hint="displayHint ? format : ''"
          :error-messages="errors"
          persistent-hint
          :readonly="isReadOnly"
          append-icon="$calendar"
          v-on="on"
          class="mb-6"
        />
      </ValidationProvider>
    </template>
    <v-date-picker
      v-bind="this.$attrs"
      v-model="date"
      @input="dropdown = !dropdown"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator(format) {
        if (format === 'DD-MM-YYYY') {
          console.error('This format is not well supported!');
        }
        return true;
      },
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayHint: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      date: this.getValidFormat(),
      changingFormat: false,
      dropdown: false,
    };
  },
  computed: {
    dateFormatted: {
      get() {
        let date = this.getValidDate();
        if (this.value !== this.$moment(date).format(this.format)) {
          this.$emit('input', date || '');
        }
        return date;
      },
      set(value) {
        let date = this.getValidDate(value) || '';
        this.$emit('input', date);
      },
    },
  },
  watch: {
    value() {
      this.date = this.getValidFormat();
    },
  },
  methods: {
    getValidFormat(date = this.value) {
      if (!date) {
        return undefined;
      }
      try {
        date = this.$moment(date, [this.format, this.$moment.ISO_8601]);
        if (date.isValid) {
          return date.format('YYYY-MM-DD');
        }
      } catch (e) {
        return undefined;
      }
    },
    getValidDate(date = this.date) {
      if (date === 'Invalid date' || !date) {
        return undefined;
      }
      try {
        date = this.$moment(date).format('YYYY-MM-DD');
        if (date.startsWith('-')) {
          date = date.replace('-', '');
        }
        date = this.$moment(date);
        if (!date.isValid) {
          throw new Error('Invalid Date');
        }
        date = date.format(this.format);
      } catch (e) {
        date = undefined;
      }
      if (date === 'Invalid date') {
        return undefined;
      }
      return date;
    },
  },
};
</script>

<style scoped></style>
